var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"icon":"","disabled":!_vm.target},on:{"click":function($event){return _vm.open()}}},on),[_c('v-icon',[_vm._v(_vm._s(_vm.button.icon || 'mdi-open-in-new'))])],1)]}}])},[_c('span',[_vm._v(_vm._s(_vm.button.tooltip || 'Apri documento'))])])}
var staticRenderFns = []

export { render, staticRenderFns }